import { ThemeConfig } from 'antd';

const COLOR_PRIMARY = '#0349AA';
const TEXT_BASE_COLOR = '#1F1F1F';
const PRIMARY100 = '#E6EDF7';
const PRIMARY0 = '#F3F6FB';
const NATURAL110 = '#1F1F1F';

export const getTheme = (isRTL: boolean): ThemeConfig => ({
  token: {
    // Seed Token
    colorPrimary: COLOR_PRIMARY,
    colorTextBase: TEXT_BASE_COLOR,
    colorLink: COLOR_PRIMARY,
    colorIconHover: COLOR_PRIMARY,
    colorLinkHover: COLOR_PRIMARY,
    colorLinkActive: COLOR_PRIMARY,
    colorFillContentHover: COLOR_PRIMARY,
    fontFamily: isRTL ? 'Cairo' : 'Noto Sans',
    fontSize: 14,
    borderRadius: 5,
    fontSizeLG: 14,
    colorBgLayout: PRIMARY0,
  },
  //table
  components: {
    Table: {
      /* here is your component tokens */
      headerBg: PRIMARY100,
      headerFilterHoverBg: PRIMARY100,
      headerBorderRadius: 8,
    },
    Pagination: {
      itemActiveBg: COLOR_PRIMARY,
    },
    Modal: {
      wireframe: true,
    },
    Form: {
      labelColor: NATURAL110,
    },
    Input: {
      colorText: NATURAL110,
    },
  },
  // Alias Token
  // colorBgContainer: '#f6ffed',8
});
